import { Link } from "react-router-dom";
import { auth } from "../config/firebase";
import { useAuthState } from "react-firebase-hooks/auth";
import { signOut } from "firebase/auth";
import logo from "../logo.svg";

export const Navbar = () => {
  const [user, loading, error] = useAuthState(auth);

  const signUserOut = async () => {
    await signOut(auth);
  };

  return (
    <nav className='navbar navbar-expand-lg navbar-dark bg-gradient'>
      <div className='container-fluid'>
        <Link className='nav-link d-flex align-items-center' to='/'>
          <img src={logo} className='App-logo' alt='logo' />
          <span className='fw-bolder'>React Social</span>
        </Link>
        <button
          className='navbar-toggler'
          type='button'
          data-bs-toggle='collapse'
          data-bs-target='#navbarNav'
          aria-controls='navbarNav'
          aria-expanded='false'
          aria-label='Toggle navigation'>
          <span className='navbar-toggler-icon'></span>
        </button>
        <div className='collapse navbar-collapse justify-content-between' id='navbarNav'>
          <ul className='navbar-nav ms-3'>
            <li className='nav-item mx-2'>
              <Link className='nav-link fw-bolder' to='/'>
                Home
              </Link>
            </li>
            {user && (
              <>
                <li className='nav-item mx-2'>
                  <Link className='nav-link fw-bolder' to='/createpost'>
                    Create post
                  </Link>
                </li>
                <li className='nav-item mx-2'>
                  <Link className='nav-link fw-bolder' to='/myposts'>
                    Your posts
                  </Link>
                </li>
              </>
            )}
          </ul>
          <ul className='navbar-nav'>
            {user && (
              <li className='nav-item d-flex justify-content-center align-items-center'>
                <Link className='nav-link d-flex' to='/account'>
                  <p className='m-0 p-0 pe-2 fw-bolder fst-italic'>{user?.displayName}</p>
                  <img src={user?.photoURL || "logo.svg"} className='rounded-circle' alt='' width={30} height={30} />
                </Link>
                <button className='btn btn-outline-light fw-bolder py-1 ms-2' onClick={signUserOut}>
                  Log out
                </button>
              </li>
            )}
            {!user && (
              <Link className='btn btn-outline-light fw-bolder py-1 ms-2' to='/account'>
                Sign In
              </Link>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
};
